import Axios from 'axios';
import connectwiseHostedAPI from '.';
import { URL_API } from '../../constants';
import { getLocalStorage, getUrlParam, isTokenAboutExpire, setLocalStorage } from '../../utils';

export const getConnectwiseAuthToken = data =>
  Axios.post(`${URL_API}/api/connectwise/auth`, data).then(res => res.data.message);

const getMemberAuth = delay =>
  new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      reject(new Error('No response from CW'));
    }, delay);
    connectwiseHostedAPI.post({ request: 'getMemberAuthentication' }, data => {
      clearTimeout(timeout);
      resolve(data);
    });
  });

const savedTokenKey = 'cwToken';

export const requestToAccessToken = async ({
  appId,
  incrementalTimeout = 1000,
  maxRetryCount = 3
} = {}) => {
  appId = appId || getUrlParam('appId');
  const locallyStoredToken = getLocalStorage(savedTokenKey);
  if (locallyStoredToken && !isTokenAboutExpire(locallyStoredToken)) {
    return locallyStoredToken;
  }

  const getMemberAuthWithRetry = async (retryCount = 1) => {
    try {
      const res = await getMemberAuth(retryCount * incrementalTimeout);
      return res;
    } catch (err) {
      if (retryCount < maxRetryCount) {
        const res = await getMemberAuthWithRetry(retryCount + 1);
        return res;
      }
      throw err;
    }
  };

  const getTokenWithRetry = async (data, retryCount = 1) => {
    try {
      const res = await getConnectwiseAuthToken(data);
      return res;
    } catch (err) {
      if (retryCount < maxRetryCount) {
        const res = await getTokenWithRetry(data, retryCount + 1);
        return res;
      }
      throw err;
    }
  };

  const {
    memberHash,
    memberContext,
    memberid,
    site: origin,
    companyid
  } = await getMemberAuthWithRetry();
  const { access_token: token } = await getTokenWithRetry({
    company_name: companyid,
    member_hash: memberHash,
    member_id: memberid,
    member_context: memberContext,
    origin,
    app_id: appId
  });
  setLocalStorage({ [savedTokenKey]: token });
  return token;
};
